// @flow
/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

/** @jsx h */

import { Component, h } from 'preact'
import { bem } from '@nrk/dh-utils'
import Link from './Link/index'
import styles from './index.css'
import type { MenuItemType } from '../types'
import { waitForScrollStop } from '../../../../lib/scrollStop'

type Props = {
  menuItems: Array<MenuItemType>,
  currentUrl: string
}

type State = {
  fixed: boolean,
  displayLeft: boolean,
  displayRight: boolean
}

class Menu extends Component<Props, State> {
  looping = false
  menuContainer: HTMLElement
  scroller: HTMLElement

  constructor () {
    super()
    this.state = {
      fixed: false,
      displayLeft: false,
      displayRight: false
    }
  }

  componentDidMount () {
    this.updatePosition()
    const element = document.querySelector(`a[href='${this.props.currentUrl}']`)
    waitForScrollStop()
      .then(() => {
        element && setTimeout(element.scrollIntoView({ inline: 'center' }), 0)
      })
  }

  componentWillUnmount () {
    this.looping = false
  }

  updatePosition () {
    const loop = () => {
      if (!this.looping) { return }

      requestAnimationFrame(loop)
      const scrollRight = this.scroller.scrollWidth - this.scroller.clientWidth - this.scroller.scrollLeft
      this.setDisplayLeft(this.scroller.scrollLeft > 10)
      this.setDisplayRight(scrollRight > 10)
      const { top } = this.menuContainer.getBoundingClientRect()
      this.setFixed(top < 0)
    }

    if (!this.looping) {
      this.looping = true
      loop()
    }
  }

  setFixed (fixed: boolean) {
    if (fixed !== this.state.fixed) {
      this.setState({ fixed })
    }
  }

  setDisplayLeft (displayLeft: boolean) {
    if (displayLeft !== this.state.displayLeft) {
      this.setState({ displayLeft })
    }
  }

  setDisplayRight (displayRight: boolean) {
    if (displayRight !== this.state.displayRight) {
      this.setState({ displayRight })
    }
  }

  render () {
    const { fixed, displayLeft, displayRight } = this.state
    const { menuItems, currentUrl } = this.props
    return (
      <div className={styles.menuContainer} ref={elm => (this.menuContainer = elm)}>
        <div className={bem(styles.menu, { fixed })}>
          <div className={styles.menu__scroller} ref={elm => (this.scroller = elm)}>
            <ul>
              {
                menuItems.map(menuItem => {
                  return <li key={menuItem.url}>
                    <Link menuItem={menuItem} current={menuItem.url === currentUrl} />
                  </li>
                })
              }
            </ul>
          </div>
          {displayLeft && (
            <div className={styles.menu__left}>
              <svg width={25} height={25} aria-hidden>
                <use xlinkHref='#nrk-chevron-left' />
              </svg>
            </div>
          )}
          {displayRight && (
            <div className={styles.menu__right}>
              <svg width={25} height={25} aria-hidden>
                <use xlinkHref='#nrk-chevron-right' />
              </svg>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Menu



// WEBPACK FOOTER //
// ./src/v1/menu/components/Menu/index.js